import { WebSocketProvider } from '@ethersproject/providers';

const provider = new WebSocketProvider(process.env.REACT_APP_ALCHEMY_URI as string);

export default provider;

